import React from "react";
import { useEditor } from "@smartfire/gutenberg-react";
import Button from "../../button/block.js";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import { Skeleton } from '@material-ui/lab';
import style from "./style.module.scss";
import clsx from "clsx";

export const Item = ({ post }) => {
    const { isEditing } = useEditor();
    const titleMaxLength = 60;
    const contentMaxLength = 200;

    return (
        <div className={clsx(isEditing && style.admin, style.item)}>
            <div className={style.coverWrapper}>
                {post._embedded['wp:featuredmedia'] &&
                    <img src={post._embedded['wp:featuredmedia'][0].source_url} alt={post._embedded['wp:featuredmedia'][0].alt_text} />
                }
            </div>
            <div className={style.contentWrapper}>
                <div className={style.content}>
                    <p
                        className={style.title}
                        dangerouslySetInnerHTML={{__html: post.title.rendered.length > titleMaxLength ? post.title.rendered.slice(0, titleMaxLength) + '...' : post.title.rendered}}
                    />
                    <p
                        className={style.excerpt}
                        dangerouslySetInnerHTML={{__html: post.content.rendered.length > contentMaxLength ? post.content.rendered.slice(0, contentMaxLength).replace(/(<([^>]+)>)/ig, '') + '...' : post.content.rendered.replace(/(<([^>]+)>)/ig, '')}}
                    />
                </div>
                <Button
                    buttonStyle={"fill"}
                    buttonPosition={"right"}
                    buttonUrl={post.link}
                    external={true}
                    picto={<KeyboardArrowRightIcon />}
                    className={style.button}
                />
            </div>
        </div>
    )
}

export default Item;
